// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Jf40","tabsBox":"styles_tabsBox__3vio2","createButton":"styles_createButton__Fz6Rc"};